import React from "react";
import { Route } from "react-router-dom";
import lazyWithRetry from "helpers/lazyWithRetry";

const GeneratorWizardPage = lazyWithRetry(() =>
  import("./GeneratorWizardPage")
);

export default [
  <Route
    exact
    path="/planning/generator"
    key="planning-generator"
    component={GeneratorWizardPage}
  />,
];
